import React from "react";
import { Paths, Domains } from "../constants/UrlConstants";
import GP247Img from "../assets/img/card-images/DCA_556x323.jpg";
import GP247ImgMobile from "../assets/img/card-images/DCA_290x170.jpg";
import HealthSupportImg from "../assets/img/card-images/Access-Health-Support_580x340.jpg";
import HealthSupportImgMobile from "../assets/img/card-images/Access-Health-Support_290x170.jpg";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import linkStyles from "../assets/css/modules/shared/link.css";
import { Link } from "react-router-dom";

const discussingMedicalDetailsFileName = "Discussing your medical details";

const Permissions = {
  PermissionsHeader: "Letters of authority",
  PermissionsDesc:
    "Below are the letters of authority for you to view and download. Please enable pop-ups when viewing them on tablets and phones.",
  HelpSection: {
    HeadingLinkTo: Paths.Help,
    HeadingLinkText: "Help",
    MoreHelpLinkTo: Paths.Help,
    MoreHelpLinkText: "View more help",
    Faq: [
      {
        Question: "What do I need to use letters of authority for?",
        Answer: {
          Any: (
            <React.Fragment>
              <p>
                You can use a letter of authority to allow us to discuss your
                medical details with a named individual, so that they can manage
                medical claims on your behalf.
              </p>
              <p>
                If you're the lead member, you can also use a letter of
                authority to give someone else permission to talk to us about
                general administration, payment of your subscriptions, changes
                to the plan, or changes to contact details.
              </p>
            </React.Fragment>
          ),
          HOL: (
            <React.Fragment>
              <p>
                You can use a letter of authority to allow us to discuss your
                medical details with a named individual, so that they can manage
                medical claims on your behalf.
              </p>
              <p>
                If you're the policyholder, you can also use a letter of
                authority to give someone else permission to talk to us about
                general administration, payment of your subscriptions, changes
                to the policy, or changes to contact details.
              </p>
            </React.Fragment>
          )
        }
      },
      {
        Question: "How do I send you a completed letter of authority?",
        Answer: {
          Any: (
            <p>
              Once you've completed a letter of authority, please scan and
              upload it via your inbox. You can attach it to a general enquiry.
            </p>
          )
        }
      }
    ],
    FaqEP:(Url,IsInternalView) => [
      {
        Question: "What do I need to use letters of authority for?",
        Answer: {
          Any: (
            <React.Fragment>
              <p>
                You can use a letter of authority to allow us to discuss your
                medical details with a named individual, so that they can manage
                medical claims on your behalf.
              </p>
              <p>
                If you're the lead member, you can also use a letter of
                authority to give someone else permission to talk to us about
                general administration, payment of your subscriptions, changes
                to the plan, or changes to contact details.
              </p>
            </React.Fragment>
          ),
          HOL: (
            <React.Fragment>
              <p>
                You can use a letter of authority to allow us to discuss your
                medical details with a named individual, so that they can manage
                medical claims on your behalf.
              </p>
              <p>
                If you're the policyholder, you can also use a letter of
                authority to give someone else permission to talk to us about
                general administration, payment of your subscriptions, changes
                to the policy, or changes to contact details.
              </p>
            </React.Fragment>
          )
        }
      },
      {
        Question: "How do I send you a completed letter of authority?",
        Answer: {
          Any: IsInternalView?(
            <p>
              Once completed, please {"  "}
              <Link to="/" 
              className={linkStyles.disabled} 
              onClick={ (event) => event.preventDefault() }>
              upload and send us your letter of authority.{" "}
              </Link>
            </p>
          ):(
            <p>
              Once completed, please {"  "}
              <a
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            href={Url}
            target="_blank"
            rel="noopener"
          >
            upload and send us your letter of authority.{" "}
          </a>
            </p>
          )
        }
      }
    ]
  },
  GP247: {
    IconSrc: {
      Any: GP247Img
    },
    IconSrcMobile: {
      Any: GP247ImgMobile
    },
    Heading: {
      Any: "GP Appointments 24/7"
    },
    Description:
      "Speak to a doctor when you want to, wherever you are, through your smartphone or laptop with AXA Doctor at Hand.",
    LinkText: {
      Any: "GP Appointments 24/7"
    },
    LinkTo: Paths.GPAppointments247,
    ExternalLinkTo: null
  },
  HealthSupport: {
    IconSrc: {
      Any: HealthSupportImg
    },
    IconSrcMobile: {
      Any: HealthSupportImgMobile
    },
    Heading: {
      Any: "Access health support"
    },
    Description:
      "We're here to support you with your health, every step of the way. Explore how we can help you and your family.",
    LinkText: {
      Any: "Health Support"
    },
    LinkTo: Paths.HealthSupport,
    ExternalLinkTo: null
  },
  Files: {
    SME: [
      {
        FileName: discussingMedicalDetailsFileName,
        ExternalLinkTo:
          Domains.AxaDomain +
          "/globalassets/uploadedfiles/applications/onlineservicing/axa/pb92076---discussing-your-medical-details-form---pmi.pdf",
        Tooltip: (
          <p>
            If you want to give someone else authority to discuss your medical
            details, please download and complete the letter of authority. Once
            complete, please upload the document via your Inbox, or send it in
            the post.
          </p>
        )
      }
    ],
    Any: [
      {
        FileName: "Make changes to your plan",
        ExternalLinkTo:
          Domains.AxaDomain +
          "/globalassets/uploadedfiles/applications/onlineservicing/axa/pb93625---loa-discussing-your-details-admin---pmi.pdf",
        Tooltip: (
          <p>
            If you're the lead member, and you want to give someone else
            authority to make changes to your plan, please download and complete
            the letter of authority. Once complete, please upload the document
            via your Inbox, or send it in the post.
          </p>
        )
      },
      {
        FileName: discussingMedicalDetailsFileName,
        ExternalLinkTo:
          Domains.AxaDomain +
          "/globalassets/uploadedfiles/applications/onlineservicing/axa/pb92076---discussing-your-medical-details-form---pmi.pdf",
        Tooltip: (
          <p>
            If you want to give someone else authority to discuss your medical
            details, please download and complete the letter of authority. Once
            complete, please upload the document via your Inbox, or send it in
            the post.
          </p>
        )
      }
    ],
    HOL: [
      {
        FileName: "Make changes to your policy",
        ExternalLinkTo:
          Domains.AxaDomain +
          "/globalassets/uploadedfiles/applications/onlineservicing/axa/pb93625---loa-discussing-your-details-admin---pmi.pdf",
        Tooltip: (
          <p>
            If you're the policyholder, and you want to give someone else
            authority to make changes to your policy, please download and
            complete the letter of authority. Once complete, please upload the
            document via your Inbox, or send it in the post.
          </p>
        )
      },
      {
        FileName: discussingMedicalDetailsFileName,
        ExternalLinkTo:
          Domains.AxaDomain +
          "/globalassets/uploadedfiles/applications/onlineservicing/axa/pb92076---discussing-your-medical-details-form---pmi.pdf",
        Tooltip: (
          <p>
            If you want to give someone else authority to discuss your medical
            details, please download and complete the letter of authority. Once
            complete, please upload the document via your Inbox, or send it in
            the post.
          </p>
        )
      }
    ]
  }
};

export default Permissions;
